export const makeBasicFilter = () => {
  return {
    filter: true,
    showFilterMatchModes: false,
    showFilterOperator: false,
    showAddButton: false
  };
};
